import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetDeliveryBoysData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { deliveryBoysColumns, statusOfDeliveryBoys } from "../../lib/definitions";
import { deleteDeliveryBoysForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import i18n from "../../lib/i18n";
import DeliveryBoysFilter from "../../ui/searchFilter/deliveryBoysFilter";
import GoogleMapPopup from "../../lib/utils/GoogleMapPopup";
import DeliveryRatingsModal from "../../ui/deliveryBoysUi/DeliveryRatingsModal";

export default function DeliveryBoys() {
  const [searchParams] = useSearchParams();
  const [deliveryBoysData, setDeliveryBoysData] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [last_page, setlast_page] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [ratingModal, setRatingModal] = useState({
    isOpen: false,
    deliveryBoyId: null
  });
  const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
  const available = searchParams.get('available');
  const name = searchParams.get('name');
  const phone = searchParams.get('phone');
  const t = i18n.t.bind(i18n);

  const params = useMemo(() => {
    const tempParams = [];
    if (phone) tempParams.push({ phone });
    if (name) tempParams.push({ name });
    if (available) tempParams.push({ available });
    return tempParams;
  }, [available, name, phone]);

  useEffect(() => {
    handleApi();
  }, [currentPage, params]);

  const handleApi = async () => {
    setIsLoading(true);
    const res = await GetDeliveryBoysData(currentPage, params);
    setDeliveryBoysData([]);
    setcurrentPage(res.pagination?.current_page || 1);
    setlast_page(res.pagination?.last_page || 1);
    res.data?.map((e) => setDeliveryBoysData((prev) => [...prev, e]));
    setIsLoading(false);
  };

  const handlePageChange = (page) => {
    setcurrentPage(page);
  };

  const openRatingModal = (id) => {
    setRatingModal({ isOpen: true, deliveryBoyId: id });
  };

  const closeRatingModal = () => {
    setRatingModal({ isOpen: false, deliveryBoyId: null });
  };

  const openDeleteConfirmation = (id) => {
    setDeleteConfirmation({ isOpen: true, idToDelete: id });
  };

  const closeDeleteConfirmation = () => {
    setDeleteConfirmation({ isOpen: false, idToDelete: null });
  };

  const handelDelete = async () => {
    if (deleteConfirmation.idToDelete) {
      setLoadingDelete(true);
      const result = await deleteDeliveryBoysForm(deleteConfirmation.idToDelete);
      if (result) {
        setLoadingDelete(false);
        handleApi();
      }
      closeDeleteConfirmation();
    }
  };

  return (
    <div className="p-8 sm:p-6 md:p-8">
      <div className="">
        <DeliveryBoysFilter statusOfDeliveryBoys={statusOfDeliveryBoys} values={params} />
      </div>

      <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly justify-between px-5 py-5 gap-4">
        <div></div>
        <Button 
          background="#2F7A74" 
          borderRadius="8px" 
          color="white" 
          padding="8px 20px" 
          text={t("button.add_deliveryBoys")} 
          nav={"/deliveryBoys/add"} 
        />
      </div>

      <div>
        {isLoading ? (
          <TableSkeleton cols={deliveryBoysColumns}/> 
        ) : (
          <Table 
            columns={deliveryBoysColumns} 
            rows={deliveryBoysData} 
            action={"map"} 
            openDeleteConfirmation={openDeleteConfirmation} 
            // 4. Pass the open function to your Table
            openOrderDetails={openRatingModal}
            edit="/deliveryBoys/edit" 
          />
        )}
      </div>

      <div className="flex justify-center items-center py-5">
        <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
      </div>

      {/* 5. Render the Rating Modal */}
      <DeliveryRatingsModal 
        isOpen={ratingModal.isOpen}
        deliveryBoyId={ratingModal.deliveryBoyId}
        onClose={closeRatingModal}
      />

      {deleteConfirmation.isOpen && (
        <DeleteRecord 
          loadingDelete={loadingDelete} 
          handelDelete={handelDelete} 
          closeDeleteConfirmation={closeDeleteConfirmation} 
        />
      )}
    </div>
  );
}